import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import HomePage from './pages/home/HomePage';
import NewTabPage from './pages/newtab/NewTabPage';

// 创建路由配置
const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/newtab',
    element: <NewTabPage />,
  },
]);

export default router; 